import { GAMES_DOC, GAMES_MAP_KEY, type GameMeta } from '@awwyeah/shared';
import { useYDoc, useYMap } from '../../sync';

/**
 * Read-only view of the family games registry (`GAMES_DOC`) for the check-in feed's
 * merge (ROADMAP "Games in the family timeline"). Duplicated rather than imported from
 * `apps/web/src/modules/games/useGamesRegistry.ts` — feature modules don't reach into each
 * other's internals (docs/ARCHITECTURE.md; the same precedent `apps/web/src/modules/
 * games/archive.ts` already notes for the reverse direction).
 *
 * This module only ever *reads* `GAMES_DOC` — the feed shows finished games, it never
 * writes to them; that belongs to the games module and its board UI.
 */
export function useGamesForFeed(): GameMeta[] {
  const doc = useYDoc(GAMES_DOC);
  const { entries } = useYMap<GameMeta>(doc, GAMES_MAP_KEY);
  return entries.map(([, meta]) => meta).filter(Boolean);
}
